const isTabbing = () => {

  document.addEventListener('keydown', (key) => handleFirstTab(key))

  const handleFirstTab = (key) => {
    if (key.keyCode === 9) {
      document.body.classList.add('user-is-tabbing')

      document.removeEventListener('keydown', handleFirstTab)
      document.addEventListener('mousedown', handleMouseDownOnce)
    }
  }

  const handleMouseDownOnce = () => {
    document.body.classList.remove('user-is-tabbing')

    document.removeEventListener('mousedown', handleMouseDownOnce)
    document.addEventListener('keydown', handleFirstTab)
  }
}

export default isTabbing


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/is-tabbing.js